var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 16C13.5216 16 15.3125 14.2091 15.3125 12C15.3125 9.79086 13.5216 8 11.3125 8C9.10336 8 7.3125 9.79086 7.3125 12C7.3125 14.2091 9.10336 16 11.3125 16Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24219 4.92969L8.48219 9.16969",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 14.8281L18.3806 19.0681",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 9.16969L18.3806 4.92969",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 9.17062L17.6706 5.64062",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24219 19.0681L8.48219 14.8281",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1346 11.999C23.1346 13.1655 22.189 14.1112 21.0224 14.1112C19.8558 14.1112 18.9102 13.1655 18.9102 11.999C18.9102 10.8324 19.8558 9.88672 21.0224 9.88672C22.189 9.88672 23.1346 10.8324 23.1346 11.999Z",
    fill: "#0D55FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0625 12C2.0625 6.89137 6.20387 2.75 11.3125 2.75C15.5059 2.75 19.0476 5.54045 20.182 9.36579C20.6088 9.13249 21.0984 8.99987 21.619 8.99987C21.6255 8.99987 21.6319 8.99989 21.6383 8.99993C20.3398 4.5228 16.2083 1.25 11.3125 1.25C5.37544 1.25 0.5625 6.06294 0.5625 12C0.5625 17.9371 5.37544 22.75 11.3125 22.75C16.2084 22.75 20.3399 19.4771 21.6384 14.9998C21.6319 14.9998 21.6255 14.9999 21.619 14.9999C21.0984 14.9999 20.6088 14.8673 20.1821 14.634C19.0478 18.4594 15.506 21.25 11.3125 21.25C6.20387 21.25 2.0625 17.1086 2.0625 12Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/life.25a6b137686fbe879681b5c0811c0d56.svg";
export { ForwardRef as ReactComponent };